import { useEffect, useMemo, useRef, useState } from "react";
import "../../Style/ai.css";
import SvgBg from "../../Component/ai/AIBackgroundSvg";
import { Link } from "react-router-dom";
import { URL } from "../../api/axiosInstance";

function CourtAI() {
  const TEXT = {
    ru: {
      title: "Kazyýet AI",
      welcomeTitle: "Добро пожаловать",
      welcomeSubtitle:
        "Kazyýet AI - помогает находить статьи, нормы и фрагменты законодательства, а также быстро ориентироваться в правовых текстах. При этом ответы сервиса носят исключительно справочный характер: он не является официальным источником правовой информации, может ошибаться, пропускать важные нормы или неточно интерпретировать запрос. Перед принятием любых юридически значимых решений обязательно сверяйте информацию с официальными текстами нормативных актов!",
      home: "Главная",
      placeholder: "Введите свой вопрос...",
      theme: "Сменить тему",
      down: "Вниз",
      send: "Отправить",
      cancel: "Отменить",
      copy: "Скопировать",
      copied: "Скопировано",
      copyFail: "Не удалось",
      online: "Online",
      offline: "Offline",
      connected: "Соединено",
      disconnected: "Нет соединения",
      failAnswer: "Не смог дать ответ.",
      connectionError: "Ошибка соединения. Попробуйте ещё раз.",
      canceled: "Запрос отменён.",
      user: "Вы",
      today: "Сегодня",
      yesterday: "Вчера",
      waitingPlaceholders: [
        "Ищу в базе законов…",
        "Проверяю статьи…",
        "Сопоставляю формулировку…",
        "Уточняю запрос…",
        "Готовлю ответ…",
      ],
      pendingTexts: {
        search: [
          "Поиск законов…",
          "Сканирую кодексы…",
          "Ищу совпадения по статьям…",
          "Сравниваю формулировки…",
          "Проверяю релевантность…",
        ],
        typing: [
          "Формирую ответ…",
          "Подбираю точные статьи…",
          "Собираю найденные фрагменты…",
          "Проверяю корректность…",
          "Почти готово…",
        ],
      },
    },
    tm: {
      title: "Kazyýet AI",
      welcomeTitle: "Hoş geldiňiz",
      welcomeSubtitle:
        "Kazyýet AI - size kanunçylyk maddalaryny, düzgünlerini we böleklerini çalt tapmaga kömek edýär. Hyzmatyň jogaplary diňe maglumat beriji häsiýete eýedir: Kazyýet AI resmi hukuk maglumat çeşmesi däldir we nätakyklyklary, goýberilen maglumatlary ýa-da düşündiriş ýalňyşlyklaryny öz içine alyp biler. Hukuk taýdan ähmiýetli çözgütleri kabul etmezden ozal, maglumatlary hökmany suratda resmi kadalaşdyryjy hukuk namalarynyň tekstleri bilen barlaň!",
      home: "Baş sahypa",
      placeholder: "Soragyňyzy giriziň...",
      theme: "Temany üýtget",
      down: "Aşak",
      send: "Ugratmak",
      cancel: "Ýatyrmak",
      copy: "Göçürmek",
      copied: "Göçürildi",
      copyFail: "Üstünlikli däl",
      online: "Online",
      offline: "Offline",
      connected: "Baglanyşyk bar",
      disconnected: "Baglanyşyk ýok",
      failAnswer: "Jogap berip bilmedim.",
      connectionError: "Baglanyşyk näsazlygy. Gaýtadan synanyşyň.",
      canceled: "Sorag ýatyryldy.",
      user: "Siz",
      today: "Şu gün",
      yesterday: "Düýn",
      waitingPlaceholders: [
        "Maglumatlary gözleýärin…",
        "Maddalary barlaýaryn…",
        "Soragy deňeşdirýärin…",
        "Soragy anyklaýaryn…",
        "Jogaby taýýarlaýaryn…",
      ],
      pendingTexts: {
        search: [
          "Maglumatlar bazasynda gözlenýär…",
          "Kodeksler barlanýar…",
          "Maddalar boýunça gözleg…",
          "Maglumatlar deňeşdirilýär…",
          "Degişlilik barlanýar…",
        ],
        typing: [
          "Jogap taýýarlanýar…",
          "Degişli maddalar saýlanýar…",
          "Tapylan bölekler ýygnalýar…",
          "Dogrylygy barlanýar…",
          "Soňky ädimler…",
        ],
      },
    },
  };

  const BACKEND_BASE_URL = URL;

  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "ru"
  );
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [connState, setConnState] = useState("offline");
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [pendingMode, setPendingMode] = useState("search");
  const [pendingPhraseIndex, setPendingPhraseIndex] = useState(0);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  // const [copiedMap, setCopiedMap] = useState({});

  const messagesRef = useRef(null);
  const inputRef = useRef(null);
  const activeControllerRef = useRef(null);
  const activeRequestSeqRef = useRef(0);
  const healthCheckTimerRef = useRef(null);
  const placeholderTimerRef = useRef(null);
  const pendingTimerRef = useRef(null);
  const mountedRef = useRef(true);
  const typingQueueRef = useRef([]);
  const typingActiveRef = useRef(false);
  const typingTimerRef = useRef(null);

  const t = TEXT[currentLanguage];

  function apiUrl(path) {
    const cleanPath = String(path || "").startsWith("/")
      ? String(path)
      : `/${String(path || "")}`;
    return `${BACKEND_BASE_URL}${cleanPath}`;
  }

  function iconSvg(name, size = 18) {
    const props = {
      className: "icon-svg",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      focusable: "false",
    };

    switch (name) {
      case "home":
        return (
          <svg {...props}>
            <path d="M3 10.5 12 3l9 7.5" />
            <path d="M5 10v10h14V10" />
            <path d="M9 20v-6h6v6" />
          </svg>
        );
      case "moon":
        return (
          <svg {...props}>
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        );
      case "sun":
        return (
          <svg {...props}>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2" />
            <path d="M12 20v2" />
            <path d="M4.93 4.93l1.41 1.41" />
            <path d="M17.66 17.66l1.41 1.41" />
            <path d="M2 12h2" />
            <path d="M20 12h2" />
            <path d="M4.93 19.07l1.41-1.41" />
            <path d="M17.66 6.34l1.41-1.41" />
          </svg>
        );
      case "send":
        return (
          <svg {...props}>
            <path d="M22 2 11 13" />
            <path d="M22 2 15 22 11 13 2 9 22 2z" />
          </svg>
        );
      case "stop":
        return (
          <svg {...props}>
            <rect x="6" y="6" width="12" height="12" rx="2" />
          </svg>
        );
      case "down":
        return (
          <svg {...props}>
            <path d="M12 5v14" />
            <path d="m19 12-7 7-7-7" />
          </svg>
        );
      case "copy":
        return (
          <svg {...props}>
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        );
      case "check":
        return (
          <svg {...props}>
            <path d="M20 6 9 17l-5-5" />
          </svg>
        );
      case "warn":
        return (
          <svg {...props}>
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
          </svg>
        );
      default:
        return null;
    }
  }

  function basePlaceholder() {
    return t.placeholder;
  }

  function isNearBottom(threshold = 140) {
    const el = messagesRef.current;
    if (!el) return true;
    return el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
  }

  function scrollToBottom(smooth = false) {
    const el = messagesRef.current;
    if (!el) return;
    if (smooth) {
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    } else {
      el.scrollTop = el.scrollHeight;
    }
    updateScrollDownButton();
  }

  function updateScrollDownButton() {
    const el = messagesRef.current;
    if (!el) return;
    const show = !isNearBottom(160) && el.scrollHeight > el.clientHeight + 40;
    setShowScrollDown(show);
  }

  const applyConnState = (state) => {
    const online = state === "online" && navigator.onLine;
    setConnState(online ? "online" : "offline");
  };

  async function checkHealth() {
    if (!navigator.onLine) {
      applyConnState("offline");
      return false;
    }

    try {
      const response = await fetch(apiUrl("/api/health/"), {
        method: "GET",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        applyConnState("offline");
        return false;
      }

      const data = await response.json();
      const ok = Boolean(data && data.ok);
      applyConnState(ok ? "online" : "offline");
      return ok;
    } catch {
      applyConnState("offline");
      return false;
    }
  }

  function dayKey(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  }

  function formatDayLabel(dateObj) {
    const now = new Date();
    const diffDays = Math.round(
      (startOfDay(now) - startOfDay(dateObj)) / 86400000
    );

    if (diffDays === 0) return t.today;
    if (diffDays === 1) return t.yesterday;

    return dateObj.toLocaleDateString(
      currentLanguage === "ru" ? "ru-RU" : "tr-TR",
      { day: "2-digit", month: "long", year: "numeric" }
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      // eslint-disable-next-line
      .replace(/\"/g, "&quot;");
  }

  function renderMessageHtml(text, type) {
    const raw = String(text || "");
    const safe = type === "user" ? escapeHtml(raw) : raw;
    return safe.replace(/\n/g, "<br>");
  }

  function normalizePayload(data) {
    if (!data || typeof data !== "object") {
      return {
        type: "error",
        content: "",
        results: [],
        recommendations: [],
        is_final: true,
      };
    }

    return {
      type: data.type || "message",
      content: data.content || "",
      results: Array.isArray(data.results) ? data.results : [],
      recommendations: Array.isArray(data.recommendations)
        ? data.recommendations
        : [],
      is_final: data.is_final === undefined ? true : Boolean(data.is_final),
    };
  }

  function stopTypewriter() {
    if (typingTimerRef.current) {
      clearInterval(typingTimerRef.current);
      typingTimerRef.current = null;
    }
  }

  function startTypewriterForMessage(messageId, fullText, recommendations = [], onDone) {
    stopTypewriter();

    const text = String(fullText || "");
    const total = text.length;

    if (!total) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId
            ? {
              ...msg,
              text,
              typedText: "",
              isTyping: false,
              recommendations,
            }
            : msg
        )
      );
      if (onDone) onDone();
      return;
    }

    let i = 0;
    const ticksTarget = Math.max(90, Math.min(260, Math.ceil(total / 4)));
    const charsPerTick = Math.max(2, Math.min(14, Math.ceil(total / ticksTarget)));
    const interval = 35;

    typingTimerRef.current = setInterval(() => {
      i = Math.min(total, i + charsPerTick);

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId
            ? {
              ...msg,
              text,
              typedText: text.slice(0, i),
              isTyping: i < total,
              recommendations: i >= total ? recommendations : [],
            }
            : msg
        )
      );

      if (isNearBottom(180)) {
        scrollToBottom(false);
      } else {
        updateScrollDownButton();
      }

      if (i >= total) {
        stopTypewriter();
        if (onDone) onDone();
      }
    }, interval);
  }

  function processTypingQueue() {
    if (!typingQueueRef.current.length) {
      typingActiveRef.current = false;
      return;
    }

    typingActiveRef.current = true;

    const task = typingQueueRef.current.shift();
    const messageId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;

    setMessages((prev) => [
      ...prev,
      {
        id: messageId,
        role: "bot",
        text: task.text || "",
        typedText: "",
        isTyping: true,
        recommendations: [],
        copyable: true,
        createdAt: new Date().toISOString(),
      },
    ]);

    requestAnimationFrame(() => {
      scrollToBottom(false);
    });

    startTypewriterForMessage(
      messageId,
      task.text || "",
      Array.isArray(task.recommendations) ? task.recommendations : [],
      () => {
        processTypingQueue();
      }
    );
  }

  function getPendingTexts(mode) {
    const pack = t.pendingTexts || TEXT.ru.pendingTexts;
    const arr = pack[mode] || pack.search || [];
    return arr.length ? arr : ["..."];
  }

  function queueBotMessages(tasks) {
    if (!Array.isArray(tasks) || !tasks.length) return;

    typingQueueRef.current.push(...tasks);

    if (!typingActiveRef.current) {
      processTypingQueue();
    }
  }

  // async function copyToClipboard(text) {                                       // bot yazgy yokarsyndaky kopy button
  //   try {
  //     if (navigator.clipboard && window.isSecureContext) {
  //       await navigator.clipboard.writeText(text);
  //       return true;
  //     }
  //   } catch { }

  //   try {
  //     const ta = document.createElement("textarea");
  //     ta.value = text;
  //     ta.setAttribute("readonly", "");
  //     ta.style.position = "fixed";
  //     ta.style.left = "-9999px";
  //     ta.style.top = "0";
  //     document.body.appendChild(ta);
  //     ta.focus();
  //     ta.select();
  //     const ok = document.execCommand("copy");
  //     document.body.removeChild(ta);
  //     return ok;
  //   } catch {
  //     return false;
  //   }
  // }

  // async function handleCopy(item) {                                          
  //   const text = String(item.text || "").trim();
  //   if (!text) return;

  //   const ok = await copyToClipboard(text);

  //   setCopiedMap((prev) => ({
  //     ...prev,
  //     [item.id]: ok ? "copied" : "fail",
  //   }));

  //   setTimeout(() => {
  //     if (!mountedRef.current) return;
  //     setCopiedMap((prev) => {
  //       const next = { ...prev };
  //       delete next[item.id];
  //       return next;
  //     });
  //   }, 1200);
  // }

  function cancelRequest(silent = true) {
    if (!isWaiting) return;

    activeRequestSeqRef.current += 1;

    if (activeControllerRef.current) {
      try {
        activeControllerRef.current.abort();
      } catch { }
      activeControllerRef.current = null;
    }

    typingQueueRef.current = [];
    typingActiveRef.current = false;
    stopTypewriter();

    setIsWaiting(false);

    if (!silent) {
      setMessages((prev) => [
        ...prev,
        {
          id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
          role: "bot",
          text: t.canceled,
          recommendations: [],
          copyable: false,
          createdAt: new Date().toISOString(),
        },
      ]);
    }
  }

  async function sendText(text, displayText = null) {
    if (isWaiting) cancelRequest(true);

    const msg = String(text || "").trim();
    if (!msg) return;

    const now = new Date();

    setMessages((prev) => [
      ...prev,
      {
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        role: "user",
        text: displayText || msg,
        recommendations: [],
        copyable: false,
        createdAt: now.toISOString(),
      },
    ]);

    setPendingMode("search");
    setPendingPhraseIndex(0);
    setIsWaiting(true);
    setInput("");

    if (inputRef.current) {
      inputRef.current.style.height = "auto";
    }

    scrollToBottom(true);

    const seq = ++activeRequestSeqRef.current;
    const controller = new AbortController();
    activeControllerRef.current = controller;

    try {
      const response = await fetch(apiUrl("/api/ai/"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          message: msg,
          language: currentLanguage,
        }),
        signal: controller.signal,
      });

      if (seq !== activeRequestSeqRef.current) return;

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const raw = await response.json();

      if (seq !== activeRequestSeqRef.current) return;

      const data = normalizePayload(raw);

      if (data.type === "error") {
        setIsWaiting(false);
        setMessages((prev) => [
          ...prev,
          {
            id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
            role: "bot",
            text: t.failAnswer,
            recommendations: [],
            copyable: false,
            createdAt: new Date().toISOString(),
          },
        ]);
        checkHealth();
        return;
      }

      const recs = data.recommendations;
      const tasks = [];
      const hasResults = Array.isArray(data.results) && data.results.length > 0;

      if (data.content) {
        tasks.push({
          text: data.content,
          recommendations: !hasResults ? recs : [],
        });
      }

      if (hasResults) {
        data.results.forEach((result, idx) => {
          if (!result || !result.formatted) return;
          tasks.push({
            text: result.formatted,
            recommendations: idx === data.results.length - 1 ? recs : [],
          });
        });
      }

      setPendingMode("typing");

      if (tasks.length) {
        queueBotMessages(tasks);
      }

      if (!tasks.length) {
        setMessages((prev) => [
          ...prev,
          {
            id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
            role: "bot",
            text: t.failAnswer,
            recommendations: [],
            copyable: false,
            createdAt: new Date().toISOString(),
          },
        ]);
      }

      if (seq !== activeRequestSeqRef.current) return;

      setIsWaiting(false);
      checkHealth();
    } catch (error) {
      if (seq !== activeRequestSeqRef.current) return;
      if (error && error.name === "AbortError") return;

      setIsWaiting(false);
      setMessages((prev) => [
        ...prev,
        {
          id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
          role: "bot",
          text: t.connectionError,
          recommendations: [],
          copyable: false,
          createdAt: new Date().toISOString(),
        },
      ]);
      applyConnState("offline");
    } finally {
      if (activeControllerRef.current === controller) {
        activeControllerRef.current = null;
      }
    }
  }

  function sendMessage() {
    const text = input.trim();
    sendText(text);
  }

  const groupedItems = useMemo(() => {
    const items = [];
    let currentDay = null;
    let lastRole = null;

    messages.forEach((msg) => {
      const dateObj = new Date(msg.createdAt);
      const k = dayKey(dateObj);

      if (k !== currentDay) {
        items.push({
          type: "day",
          id: `day_${k}`,
          day: k,
          label: formatDayLabel(dateObj),
        });
        currentDay = k;
        lastRole = null;
      }

      items.push({
        ...msg,
        type: "message",
        grouped: msg.role === lastRole,
      });

      lastRole = msg.role;
    });

    return items;
    // eslint-disable-next-line
  }, [messages, currentLanguage]);

  const currentPendingText = useMemo(() => {
    const arr = getPendingTexts(pendingMode);
    return arr[pendingPhraseIndex % arr.length];
    // eslint-disable-next-line
  }, [pendingMode, pendingPhraseIndex, currentLanguage]);

  const currentPlaceholder = useMemo(() => {
    if (!isWaiting) return basePlaceholder();
    const arr = t.waitingPlaceholders || TEXT.ru.waitingPlaceholders;
    return arr[placeholderIndex % arr.length] || basePlaceholder();
    // eslint-disable-next-line
  }, [isWaiting, placeholderIndex, currentLanguage]);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (activeControllerRef.current) {
        try {
          activeControllerRef.current.abort();
        } catch { }
      }
      stopTypewriter();
      if (healthCheckTimerRef.current)
        clearInterval(healthCheckTimerRef.current);
      if (placeholderTimerRef.current)
        clearInterval(placeholderTimerRef.current);
      if (pendingTimerRef.current) clearInterval(pendingTimerRef.current);
    };
  }, []);

  useEffect(() => {
    const setViewportHeight = () => {
      const height = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty(
        "--court-ai-vh",
        `${height}px`
      );
    };

    setViewportHeight();

    window.visualViewport?.addEventListener("resize", setViewportHeight);
    window.visualViewport?.addEventListener("scroll", setViewportHeight);
    window.addEventListener("resize", setViewportHeight);

    return () => {
      window.visualViewport?.removeEventListener("resize", setViewportHeight);
      window.visualViewport?.removeEventListener("scroll", setViewportHeight);
      window.removeEventListener("resize", setViewportHeight);
      document.documentElement.style.removeProperty("--court-ai-vh");
    };
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("language", currentLanguage);
  }, [currentLanguage]);

  useEffect(() => {
    checkHealth();
    if (healthCheckTimerRef.current)
      clearInterval(healthCheckTimerRef.current);
    healthCheckTimerRef.current = setInterval(checkHealth, 30000);

    const handleOnline = () => checkHealth();
    const handleOffline = () => applyConnState("offline");

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if (healthCheckTimerRef.current)
        clearInterval(healthCheckTimerRef.current);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (placeholderTimerRef.current)
      clearInterval(placeholderTimerRef.current);

    if (isWaiting) {
      setPlaceholderIndex(0);
      placeholderTimerRef.current = setInterval(() => {
        setPlaceholderIndex((prev) => prev + 1);
      }, 100000);
    } else {
      setPlaceholderIndex(0);
    }

    return () => {
      if (placeholderTimerRef.current)
        clearInterval(placeholderTimerRef.current);
    };
  }, [isWaiting, currentLanguage]);

  useEffect(() => {
    if (pendingTimerRef.current) clearInterval(pendingTimerRef.current);

    if (isWaiting) {
      setPendingPhraseIndex(0);
      pendingTimerRef.current = setInterval(() => {
        setPendingPhraseIndex((prev) => prev + 1);
      }, 10000);
    } else {
      setPendingPhraseIndex(0);
    }

    return () => {
      if (pendingTimerRef.current) clearInterval(pendingTimerRef.current);
    };
  }, [isWaiting, pendingMode, currentLanguage]);

  useEffect(() => {
    requestAnimationFrame(() => {
      updateScrollDownButton();
    });
    // eslint-disable-next-line
  }, [messages.length, isWaiting]);

  return (
    <>
      <div className="court-ai-page">
        <div className="court-ai-app">
          <header className="court-ai-header">
            <div className="court-ai-header-left">
              <div className="court-ai-title-wrap">
                <span className="court-ai-logo-wrap">
                  <img
                    className="court-ai-app-logo"
                    src="logo.png"
                    alt="Logo"
                  />
                  <h1 className="court-ai-title">{t.title}</h1>
                </span>
                <div
                  className={`court-ai-conn-status ${connState === "online" ? "online" : "offline"
                    }`}
                  title={connState === "online" ? t.connected : t.disconnected}
                >
                  <span className="dot"></span>
                  <span>
                    {connState === "online" ? t.online : t.offline}
                  </span>

                </div>
              </div>
            </div>

            <div className="court-ai-header-right">
              <select
                className="court-ai-language-select"
                value={currentLanguage}
                onChange={(e) => setCurrentLanguage(e.target.value)}
              >
                <option value="ru">Русский</option>
                <option value="tm">Türkmençe</option>
              </select>

              <Link
                to="/"
                className="court-ai-home-btn"
                title={t.home}
                aria-label={t.home}
              >
                <span className="ico">{iconSvg("home", 18)}</span>
                <span className="court-ai-home-text">{t.home}</span>
              </Link>

              <button
                className="court-ai-theme-toggle"
                title={t.theme}
                aria-label={t.theme}
                type="button"
                onClick={() =>
                  setTheme((prev) => (prev === "dark" ? "light" : "dark"))
                }
              >
                <span className="ico">
                  {theme === "dark"
                    ? iconSvg("moon", 20)
                    : iconSvg("sun", 20)}
                </span>
              </button>
            </div>
          </header>

          <div className="court-ai-messages-wrap">
            <SvgBg />

            <div
              className="court-ai-messages"
              ref={messagesRef}
              onScroll={() => updateScrollDownButton()}
            >
              {groupedItems.map((item) =>
                item.type === "day" ? (
                  <div
                    className="court-ai-day-divider"
                    key={item.id}
                    data-day={item.day}
                  >
                    <span>{item.label}</span>
                  </div>
                ) : (
                  <div
                    className={`court-ai-msg-row ${item.role} ${item.grouped ? "grouped" : ""
                      }`}
                    key={item.id}
                  >
                    <div className="court-ai-avatar">
                      {item.role === "user" ? t.user : "AI"}
                    </div>

                    <div
                      className={`court-ai-bubble ${item.role === "bot" && item.copyable !== false
                        ? "copyable"
                        : ""
                        }`}
                    >
                      {/* {item.role === "bot" && item.copyable !== false && (                                        //  bu bot yazgylaryny kopyalamak uçin button
                        <button
                          className={`court-ai-copy-btn ${copiedMap[item.id] === "copied" ? "copied" : ""
                            }`}
                          type="button"
                          title={
                            copiedMap[item.id] === "copied"
                              ? t.copied
                              : copiedMap[item.id] === "fail"
                                ? t.copyFail
                                : t.copy
                          }
                          aria-label={
                            copiedMap[item.id] === "copied"
                              ? t.copied
                              : copiedMap[item.id] === "fail"
                                ? t.copyFail
                                : t.copy
                          }
                          onClick={() => handleCopy(item)}
                        >
                          <span className="ico">
                            {copiedMap[item.id] === "copied"
                              ? iconSvg("check", 18)
                              : copiedMap[item.id] === "fail"
                                ? iconSvg("warn", 18)
                                : iconSvg("copy", 18)}
                          </span>
                        </button>
                      )} */}

                      <div
                        className="court-ai-msg-text"
                        dangerouslySetInnerHTML={{
                          __html: renderMessageHtml(
                            item.isTyping ? item.typedText : item.text,
                            item.role
                          ),
                        }}
                      />

                      {item.isTyping && <span className="cursor">▍</span>}

                      {item.role === "bot" &&
                        Array.isArray(item.recommendations) &&
                        item.recommendations.length > 0 && (
                          <div className="court-ai-recommendations show">
                            {item.recommendations.map((r, idx) => {
                              const label = r?.label || "";
                              const q = r?.query || "";
                              const userText =
                                r?.user_text || r?.query || r?.label || "";

                              return (
                                <button
                                  className="court-ai-rec-btn"
                                  type="button"
                                  key={`${item.id}_${idx}`}
                                  onClick={() => {
                                    if (q) {
                                      sendText(q, userText || null);
                                      scrollToBottom(true);
                                    }
                                  }}
                                >
                                  {label}
                                </button>
                              );
                            })}
                          </div>
                        )}
                    </div>
                  </div>
                )
              )}

              {isWaiting && (
                <div
                  className={`court-ai-msg-row bot ${messages.length &&
                    messages[messages.length - 1]?.role === "bot"
                    ? "grouped"
                    : ""
                    }`}
                >
                  <div className="court-ai-avatar">AI</div>
                  <div className="court-ai-bubble">
                    <span className="court-ai-typing-line">
                      <span className="court-ai-pending-text">
                        {currentPendingText}
                      </span>
                      <span className="court-ai-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </span>
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className={`court-ai-welcome ${messages.length ? "hide" : ""}`}>
              <div className="court-ai-welcome-card">
                <img
                  className="court-ai-welcome-logo"
                  src="logo.png"
                  alt="Logo"
                />
                <div className="court-ai-welcome-title">
                  {t.welcomeTitle}
                </div>
                <div className="court-ai-welcome-subtitle">
                  {t.welcomeSubtitle}
                </div>
              </div>
            </div>
          </div>

          <div className="court-ai-input-area">
            <div className="court-ai-input-wrapper">
              <textarea
                ref={inputRef}
                className="court-ai-textarea"
                value={input}
                placeholder={currentPlaceholder}
                rows="1"
                onChange={(e) => {
                  setInput(e.target.value);
                  e.target.style.height = "auto";
                  e.target.style.height = `${Math.min(
                    e.target.scrollHeight,
                    140
                  )}px`;
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();

                    const txt = input.trim();

                    if (isWaiting) {
                      if (txt) {
                        cancelRequest(true);
                        setTimeout(() => sendText(txt), 60);
                      } else {
                        cancelRequest(false);
                      }
                      return;
                    }

                    if (txt) sendMessage();
                  }
                }}
              />

              <button
                className="court-ai-send"
                disabled={isWaiting ? false : !input.trim()}
                aria-label={isWaiting ? t.cancel : t.send}
                title={isWaiting ? t.cancel : t.send}
                type="button"
                onClick={() => {
                  if (isWaiting) cancelRequest(false);
                  else sendMessage();
                }}
              >
                <span className="ico">
                  {isWaiting ? iconSvg("stop", 18) : iconSvg("send", 18)}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        className={`court-ai-scroll-down ${showScrollDown ? "show" : ""}`}
        aria-label={t.down}
        title={t.down}
        type="button"
        onClick={() => scrollToBottom(true)}
      >
        <span className="ico">{iconSvg("down", 18)}</span>
      </button>
    </>
  );
}

export default CourtAI;